export default function NEPAlignment() {
  const alignments = [
    {
      icon: 'ri-hand-heart-line',
      title: 'Competency-Based Learning',
      description: 'Hands-on projects and problem-solving activities that develop critical thinking, creativity, and practical skills aligned with NEP 2020 competency framework.',
      boards: ['CBSE', 'ICSE', 'State Boards']
    },
    {
      icon: 'ri-links-line',
      title: 'Multidisciplinary Approach',
      description: 'Seamless integration with Mathematics, Science, and Computer Science curricula, breaking traditional subject silos for holistic learning.',
      boards: ['CBSE', 'ICSE', 'State Boards']
    },
    {
      icon: 'ri-tools-line',
      title: 'Skill Development Focus',
      description: 'Emphasis on coding, robotics, AI literacy, design thinking, and 21st-century skills that prepare students for future careers.',
      boards: ['CBSE', 'ICSE', 'State Boards']
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Hero Statement */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-500 rounded-3xl p-12 mb-16 text-center">
          <div className="max-w-4xl mx-auto">
            <i className="ri-double-quotes-l text-4xl text-blue-200 mb-4"></i>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-relaxed">
              Aligned with National Education Policy 2020 – Experiential Learning, Skill Development, and 21st Century Competencies
            </h2>
            <i className="ri-double-quotes-r text-4xl text-blue-200 mt-4"></i>
          </div>
        </div>

        {/* Alignment Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {alignments.map((item, idx) => (
            <div
              key={idx}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              {/* Icon */}
              <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-600 to-blue-400 flex items-center justify-center mb-5 shadow-lg">
                <i className={`${item.icon} text-3xl text-white`}></i>
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>

              {/* Description */}
              <p className="text-gray-600 text-sm mb-5 leading-relaxed">{item.description}</p>

              {/* Board Badges */}
              <div className="flex flex-wrap gap-2">
                {item.boards.map((board, bIdx) => (
                  <span
                    key={bIdx}
                    className="inline-flex items-center gap-2 px-3 py-1 bg-green-100 text-green-700 text-sm font-medium rounded-full"
                  >
                    <i className="ri-checkbox-circle-fill"></i>
                    {board}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Curriculum Mapping Visualizer */}
        <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-3xl p-12">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-6">
            Curriculum Mapping &amp; Integration
          </h3>
          <p className="text-base text-gray-600 text-center mb-10 max-w-3xl mx-auto">
            Our modules seamlessly integrate with your existing curriculum, enhancing learning outcomes across subjects
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { subject: 'Mathematics', topics: ['Geometry', 'Algebra', 'Statistics'], icon: 'ri-calculator-line', color: 'from-blue-500 to-blue-600' },
              { subject: 'Science', topics: ['Physics', 'Chemistry', 'Biology'], icon: 'ri-flask-line', color: 'from-green-500 to-green-600' },
              { subject: 'Computer Science', topics: ['Programming', 'Algorithms', 'Data Structures'], icon: 'ri-code-s-slash-line', color: 'from-purple-500 to-purple-600' },
              { subject: 'Design & Arts', topics: ['CAD', '3D Modeling', 'Creative Design'], icon: 'ri-palette-line', color: 'from-pink-500 to-pink-600' }
            ].map((subject, idx) => (
              <div
                key={idx}
                className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-1"
              >
                <div className={`w-12 h-12 rounded-lg bg-gradient-to-br ${subject.color} flex items-center justify-center mb-3`}>
                  <i className={`${subject.icon} text-2xl text-white`}></i>
                </div>
                <h4 className="text-base font-bold text-gray-900 mb-3">{subject.subject}</h4>
                <ul className="space-y-2">
                  {subject.topics.map((topic, tIdx) => (
                    <li key={tIdx} className="flex items-center gap-2 text-gray-600">
                      <i className="ri-arrow-right-s-line text-blue-600"></i>
                      <span className="text-sm">{topic}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
